import React from "react";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import Checkbox from "@CheckoutStepsOffers/components/atoms/Checkbox";
import CreditCardInput from "@CheckoutStepsOffers/components/atoms/CreditCardInput";
import Input from "@CheckoutStepsOffers/components/atoms/Input";
import InputMask from "@CheckoutStepsOffers/components/atoms/InputMask";
import Select from "@CheckoutStepsOffers/components/atoms/Select";
import AddressForm from "@CheckoutStepsOffers/components/templates/AddressForm";
import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";
import { WrapperInputs } from "@CheckoutStepsOffers/styles/WrapperInputs";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { Scope } from "@unform/core";

import usePaymentContext from "../../provider";
import {
  ArrowLeftIcon,
  Container,
  ReturnToCardListButton,
  WrapperCreditCardInputs,
} from "./styles";

const CreditCardForm = () => {
  const { state } = useGlobalContext();
  const { creditCardState, country } = useCheckoutContext();
  const {
    offer,
    installments,
    installmentOptions,
    installmentSelected,
    handleSelectInstallment,
  } = useCheckoutStepsOffersContext();
  const { formRef, setOpenCreditCardForm } = usePaymentContext();

  const onlyNumber = /[^0-9]/g;

  const acquirer = state?.tenancy?.acquirer;
  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0].value < acquirer?.min_value;

  return (
    <>
      <Container>
        {!!creditCardState.creditCardList?.length && (
          <ReturnToCardListButton
            type="button"
            onClick={() => setOpenCreditCardForm(false)}
          >
            <ArrowLeftIcon />
            Voltar para lista de cartões
          </ReturnToCardListButton>
        )}

        <Scope path="credit_card_form">
          <WrapperInputs>
            <Input
              required
              toUpperCase
              name="card_holder_name"
              label="Nome impresso no cartão"
              placeholder="Digite o nome impresso no cartão"
            />
          </WrapperInputs>

          <WrapperCreditCardInputs>
            <CreditCardInput
              required
              name="card_number"
              label="Número do cartão"
              placeholder="0000 0000 0000 0000"
            />

            <InputMask
              required
              name="card_expiration_date"
              mask="99/99"
              placeholder="MM/AA"
              className="expiration_date"
            />

            <Input
              required
              name="card_cvv"
              maxLength={4}
              placeholder="CVV"
              replace={onlyNumber}
              className="cvv"
              inputMode="numeric"
            />
          </WrapperCreditCardInputs>

          {!IS_MIN_VALUE && country === "Brasil" && (
            <WrapperInputs>
              <Select
                required
                name="installments"
                label="Parcelas disponiveis"
                options={installmentOptions}
                defaultValue={installmentSelected.installment.toString()}
                onChangeCustom={(option) => {
                  const value = option.value;

                  handleSelectInstallment(value);
                }}
              />
            </WrapperInputs>
          )}
        </Scope>
      </Container>

      {offer.offer.details.ask_for_address === 1 && country === "Brasil" && (
        <Container className="address-container">
          <AddressForm
            formRef={formRef}
            title="Dados para Nota Fiscal eletrônica"
          />
        </Container>
      )}
    </>
  );
};

export default CreditCardForm;
